import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import { Button } from '@fiverr-private/fit';
import { numberFormat } from '@fiverr-private/localization';
import * as Error from '../../utils/error';
import { showErrorToast, showSuccessToast } from '../ButterToasts';
import reportToBigQuery from '../../../Utils/bigQueryReporter';
import NameModal from '../NameModal';
import { sendMixPanelEvent } from '../../../Utils/mixpanel';
import { SUBMIT_COMMENTS } from '../../../Utils/mixpanel/mixpanelEvents';
import * as CommentsSelectors from '../../selectors/comments';
import * as CommentsActions from '../../actions/comments';
import * as CollaboratorsSelectors from '../../selectors/collaborators';
import * as FilesSelectors from '../../selectors/files';
import * as CurrentsSelectors from '../../selectors/current';
import * as SettingsSelectors from '../../selectors/settings';
import * as Translations from '../../providers/i18n';

import './style.scss';

export class CommentsSubmitAllButton extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            shouldShowNameModal: false
        };
    }

    clickHandler = () => {
        const {
            isEnabledToCreateComments,
            currentCollaboratorUsername,
            pendingComments,
            createComments,
            onSubmit,
            onClick,
            numberOfComments,
            numberOfFiles,
            userId,
            source,
            i18n
        } = this.props;

        if (!isEnabledToCreateComments) { return; }
        if (!currentCollaboratorUsername) {
            this.setState({ shouldShowNameModal: true });
            return;
        }

        const payload = {
            comments: pendingComments
        };

        reportToBigQuery({
            type: 'clicked_comment_submit_in_collaboration_conversation',
            group: 'collaboration',
            collaboration: {
                total_comments: numberOfComments
            }
        });

        sendMixPanelEvent({
            eventName: SUBMIT_COMMENTS,
            eventData: {
                'Number of Comments': numberOfComments,
                'Number of Files': numberOfFiles,
                'Is Collaborator': !userId,
                'Related Flow': source
            }
        });

        createComments(payload)
            .then((commentIds) => {
                const formattedCommentsLength = numberFormat(commentIds.length, {
                    fallbackValue: commentIds.length
                });
                showSuccessToast(i18n.t('attachments_preview.collaboration.toasts.comments_submited', { count: formattedCommentsLength }));
            }).then(() =>
                onSubmit && onSubmit()
            ).catch((error) => {
                Error.send(error, 'CommentsSubmitAllButtonComponents');
                showErrorToast(i18n.t('attachments_preview.collaboration.toasts.error'));
            });

        onClick();
    };

    render() {
        const {
            numberOfComments,
            isEnabledToCreateComments,
            i18n
        } = this.props;

        const {
            shouldShowNameModal
        } = this.state;

        let submitCommentsText = i18n.t('attachments_preview.collaboration.comments.submit_comments');

        if (numberOfComments) {
            const formattedNumberOfComments = numberFormat(numberOfComments, {
                fallbackValue: numberOfComments
            });
            submitCommentsText = i18n.t('attachments_preview.collaboration.comments.submit_num_comments', { count: formattedNumberOfComments });
        }

        return (
            <div>
                <div className="submit-wrapper">
                    <Button className="submit-all-btn" disabled={!isEnabledToCreateComments} onClick={this.clickHandler}>
                        {submitCommentsText}
                    </Button>
                </div>
                {shouldShowNameModal && <NameModal/>}
            </div>
        );
    }
}

CommentsSubmitAllButton.propTypes = {
    isEnabledToCreateComments: PropTypes.bool,
    numberOfComments: PropTypes.number,
    createComments: PropTypes.func,
    onSubmit: PropTypes.func,
    pendingComments: PropTypes.array,
    onClick: PropTypes.func,
    currentCollaboratorUsername: PropTypes.string,
    userId: PropTypes.number,
    numberOfFiles: PropTypes.number,
    source: PropTypes.string,
    i18n: PropTypes.shape({
        t: PropTypes.func
    })
};

CommentsSubmitAllButton.defaultProps = {
    onClick: () => null,
    onSubmit: () => null
};

const mapStateToProps = (state) => ({
    isEnabledToCreateComments: CommentsSelectors.canCreateComments(state),
    numberOfComments: CommentsSelectors.getPendingIdsLength(state),
    pendingComments: CommentsSelectors.getPendingComments(state),
    currentCollaboratorUsername: CollaboratorsSelectors.getCurrentCollaboratorUsername(state),
    numberOfFiles: FilesSelectors.getFilesCount(state),
    userId: CurrentsSelectors.getCurrentUserId(state),
    source: SettingsSelectors.getSource(state)
});

export default compose(
    Translations.connect,
    connect(mapStateToProps, {
        createComments: CommentsActions.createComments
    }))(CommentsSubmitAllButton);
